import DTO from './DTO';

class CarriageContractDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'carrier_registry_number',
        type: String,
        validators: [],
        labelKey: 'Номер разрешения перевозчика (опционально)',
      },
      {
        name: 'carrier_inn',
        type: String,
        validators: [],
        labelKey: 'ИНН Перевозчика',
      },
      {
        name: 'carriage_contract_effective_date',
        type: String,
        validators: [],
        labelKey: 'carriage_contract_effective_date',
      },
      {
        name: 'carriage_contract_expiration_date',
        type: String,
        validators: [],
        labelKey: 'carriage_contract_expiration_date',
      },
      {
        name: 'carriage_contract_number',
        type: String,
        validators: [],
        labelKey: 'carriage_contract_number',
      },
      {
        name: 'vehicle_registry_numbers',
        type: String,
        validators: [],
        labelKey: 'Номер(-а) реестровой(-ых) записи(-ей) ЛТ для договора обеспечения',
      },
      {
        name: 'carriage_file',
        type: String,
        validators: [],
        labelKey: 'carriage_file',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default CarriageContractDTO;
